import { render, staticRenderFns } from "./educationDivision3.vue?vue&type=template&id=3045eff4"
import script from "./educationDivision3.vue?vue&type=script&lang=js"
export * from "./educationDivision3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3045eff4')) {
      api.createRecord('3045eff4', component.options)
    } else {
      api.reload('3045eff4', component.options)
    }
    module.hot.accept("./educationDivision3.vue?vue&type=template&id=3045eff4", function () {
      api.rerender('3045eff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivision3.vue"
export default component.exports